import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import * as R from 'ramda';

const propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
};

const defaultProps = {
    children: 'Reset',
    onClick: () => {},
};

function ResetButton({ children, onClick }) {
    const { handleReset } = useFormikContext();
    return (
        <Button type="button" variant="outline-secondary" onClick={R.compose(handleReset, onClick)}>
            {children || 'Reset'}
        </Button>
    );
}

ResetButton.propTypes = propTypes;
ResetButton.defaultProps = defaultProps;

export default ResetButton;
